const EditIcon = () => {
    return (
        <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.48128 0.784253L0.84375 4.42188V6.36632H2.78819L6.42574 2.72868C6.72947 2.42494 6.72947 1.93248 6.42573 1.62875L5.58123 0.784245C5.27748 0.480502 4.78502 0.480505 4.48128 0.784253Z" stroke="white"/>
        </svg>
        
    )
  }
  
  export default EditIcon
  